import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { dayTheme, nightTheme } from "./styles/theme";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalContextProvider } from "./services/context";
import React, { Suspense, useContext } from "react";
import { CustomLoader } from "./components";
import { CustomThemeContext } from "./styles/themeContext";
import DemoModeIndicator from "./components/DemoModeIndicator";
import DemoControlPanel from "./components/DemoControlPanel";

const AppRoutes = React.lazy(() => import("./Routes"));
const CookiesPrompt = React.lazy(() => import("./components/CookiesPrompt"));

export default function App() {
  const { theme, setTheme } = useContext(CustomThemeContext);
  return (
    <GlobalContextProvider>
      <ThemeProvider theme={theme === "dark" ? nightTheme : dayTheme}>
        <Router>
          <Suspense fallback={<CustomLoader isOpen={true} />}>
            <AppRoutes />
            <CookiesPrompt />
            <DemoModeIndicator />
            <DemoControlPanel />
          </Suspense>
        </Router>
        <ToastContainer />
      </ThemeProvider>
    </GlobalContextProvider>
  );
}
